module.exports = __webpack_public_path__ + "media/loginBg.85dcea64.mp4";